module.exports = __webpack_public_path__ + "img/HTML_CONTENT.2ac040aa.svg";